import React, { memo } from 'react';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/modal';
import { Box, Flex, Heading, Text } from '@chakra-ui/layout';

import { Unform, Button, CustomIcon } from 'components';
import { IUsersData } from 'types/users';

interface IModal {
  onClose: () => void;
  onOpen: () => void;
  handleChangeStatus: (userId: number, enabled: boolean) => Promise<void>;
  isOpen: boolean;
  user?: IUsersData;
  isLoading?: boolean;
  isSaving?: boolean;
  userEnadleb?: boolean;
  users?: {
    active: string;
    inactive: string;
  };
  id?: number;
}

const ModalAvailableOrUnableUser: React.FC<IModal> = ({
  onClose,
  isOpen,
  handleChangeStatus,
  user,
  isSaving,
  userEnadleb,
  id,
}) => {
  // const [isLoading, setIsLoading] = React.useState(false);
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      {user ? (
        <ModalContent
          maxW="600px"
          p="24px"
          paddingBottom={'5px'}
          w="571px"
          minH="210px"
          borderRadius="8px"
        >
          <Unform>
            <ModalHeader
              display="flex"
              p="0"
              mb="1rem"
              alignItems="center"
              justifyContent="space-between"
            >
              <Heading fontSize="18px" fontWeight="bold" color="brand.gray600">
                {user?.enabled ? 'Desativar Usuário ' : 'Ativar Usuário '}
              </Heading>
              <Box
                bg="brand.1300"
                borderRadius="50%"
                fontSize="14px"
                fontWeight="bold"
                display="flex"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                as="button"
                type="button"
                border="none"
                color="brand.red100"
                onClick={onClose}
              >
                <CustomIcon size="22px" $noSphere icon="round_close" />
              </Box>
            </ModalHeader>

            <ModalBody w="auto" maxW="full" p="0" marginBlock="2rem">
              <Flex>
                <Box>
                  <Text as={'p'} color="#000" fontWeight={600}>
                    {user?.enabled
                      ? 'Você realmente deseja desativar o usuário?'
                      : 'Você realmente deseja ativar o usuário?'}
                  </Text>
                </Box>
              </Flex>
            </ModalBody>

            <ModalFooter w="100%" display="flex" justifyContent={'center'} marginTop={'-8px'}>
              <Flex w="80%" justifyContent="space-evenly">
                <Box marginRight="1rem">
                  <Button outline variant="gray" type="button" onClick={onClose}>
                    Não
                  </Button>
                </Box>
                <Box>
                  <Button
                    type="button"
                    onClick={() => handleChangeStatus(user?.id as number, !user?.enabled)}
                    isLoading={isSaving}
                    variant="danger"
                  >
                    {user?.enabled ? 'Sim, quero desativar' : 'Sim, quero ativar'}
                  </Button>
                </Box>
              </Flex>
            </ModalFooter>
          </Unform>
        </ModalContent>
      ) : (
        <ModalContent
          maxW="600px"
          p="24px"
          paddingBottom={'5px'}
          w="571px"
          minH="210px"
          borderRadius="8px"
        >
          <Unform>
            <ModalHeader
              display="flex"
              p="0"
              mb="1rem"
              alignItems="center"
              justifyContent="space-between"
            >
              <Heading fontSize="18px" fontWeight="bold" color="brand.gray600">
                {userEnadleb ? 'Desativar Usuário ' : 'Ativar Usuário '}
              </Heading>
              <Box
                bg="brand.1300"
                borderRadius="50%"
                fontSize="14px"
                fontWeight="bold"
                display="flex"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                as="button"
                type="button"
                border="none"
                color="brand.red100"
                onClick={onClose}
              >
                <CustomIcon size="22px" $noSphere icon="round_close" />
              </Box>
            </ModalHeader>

            <ModalBody w="auto" maxW="full" p="0" marginBlock="2rem">
              <Flex>
                <Box>
                  <Text as={'p'} color="#000" fontWeight={600}>
                    {userEnadleb
                      ? 'Você realmente deseja desativar o usuário?'
                      : 'Você realmente deseja ativar o usuário?'}
                  </Text>
                </Box>
              </Flex>
            </ModalBody>

            <ModalFooter w="100%" display="flex" justifyContent={'center'} marginTop={'-8px'}>
              <Flex w="80%" justifyContent="space-evenly">
                <Box marginRight="1rem">
                  <Button outline variant="gray" type="button" onClick={onClose}>
                    Não
                  </Button>
                </Box>
                <Box>
                  <Button
                    type="button"
                    onClick={() => {
                      handleChangeStatus(id as number, !userEnadleb);
                      // window.location.reload();
                    }}
                    isLoading={isSaving}
                    variant="danger"
                  >
                    {userEnadleb ? 'Sim, quero desativar' : 'Sim, quero ativar'}
                  </Button>
                </Box>
              </Flex>
            </ModalFooter>
          </Unform>
        </ModalContent>
      )}
    </Modal>
  );
};

export const ModalActiveOrInactiveUser = memo(ModalAvailableOrUnableUser);
